import { Injectable } from '@angular/core';
import { LocalNotifications, ActionPerformed as LocalActionPerformed, LocalNotificationSchema, LocalNotificationDescriptor, ActionType, DeliveredNotificationSchema, DeliveredNotifications } from '@capacitor/local-notifications';
import { Platform } from '@ionic/angular';
import { Subject } from 'rxjs';
import { LOCAL_NOTIFICATION_SOUND, LOCAL_NOTIFICATION_ACTION_TYPE } from '../enums/notification/notification.enum';
import { NotificationEvent } from '../models/notification/notification-types';

@Injectable()
export class LocalNotificationService {
  private emitLocalNotification = new Subject<NotificationEvent>();
  localNotificationChange = this.emitLocalNotification.asObservable();

  constructor(private platform: Platform) {}

  async listenForEvents(types: ActionType[]) {
    await LocalNotifications.requestPermissions();

    if (this.platform.is('capacitor')) {
      if (this.platform.is('android')) {
        await LocalNotifications.createChannel({ id: 'Recovery Trac', name: 'Recovery Trac', importance: 5, sound: LOCAL_NOTIFICATION_SOUND.BEEP, vibration: true, visibility: 1 });
      }

      await LocalNotifications.registerActionTypes({
        types,
      });
    }

    await LocalNotifications.removeAllListeners();
    await LocalNotifications.addListener('localNotificationReceived', async (notification: LocalNotificationSchema) => {
      this.emitLocalNotification.next({ data: { date: Date(), notification: notification, content: notification, isRead: false }, type: 'received' });
    });
    await LocalNotifications.addListener('localNotificationActionPerformed', async (notification: LocalActionPerformed) => {
      this.emitLocalNotification.next({ data: { date: Date(), notification: notification, content: notification.notification, actionId: notification.actionId, inputValue: notification.inputValue, isRead: false }, type: 'performed' });
    });
  }

  async scheduleLocalNotification(schema: Omit<LocalNotificationSchema, 'channelId'>): Promise<LocalNotificationDescriptor> {
    const localNotification = schema as LocalNotificationSchema;
    await this.cancelScheduledNotificationById(localNotification.id);
    if (!localNotification.actionTypeId && localNotification.id in LOCAL_NOTIFICATION_ACTION_TYPE) {
      localNotification.actionTypeId = localNotification.id.toString();
    }
    if (this.platform.is('android') && localNotification.sound) {
      localNotification.channelId = 'Recovery Trac';
    }
    const result = await LocalNotifications.schedule({ notifications: [localNotification] });
    const notification = result.notifications[0];
    return notification;
  }

  async cancelScheduledNotificationById(id: number) {
    await LocalNotifications.cancel({ notifications: [{ id }] });
  }

  async removeDeliveredNotifications(notifications: DeliveredNotifications) {
    await LocalNotifications.removeDeliveredNotifications(notifications);
  };
}
